<template>
    <v-container grid-list-xl fluid>
        <v-layout wrap>
            <v-flex xs12>
                <h1>Insucesso</h1>
                <v-divider class=" mb-2" />
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step >= 1">
            <v-flex xs12>
                <div class="subtitle-1" v-if="item.code"><strong>Código:</strong> {{ item.code }}</div>
                <div class="subtitle-1" v-if="item.store"><strong>Loja:</strong> {{ item.store.name }}</div>
                <div class="subtitle-1" v-if="hasDriver"><strong>Motorista:</strong> {{ driverName }}</div>
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step == null">
            <ChecklistHistory type="return" label="Últimos insucessos" @reopen="reopen" />
            <StoreList labelNotFound="Não foi localizado nenhuma CD." labelSelect="Selecione abaixo o CD que você está sendo feito a devolução:" endpoint="checklists/return/stores"
                @selected="start" />
        </v-layout>

        <v-layout wrap v-else-if="step == 1">
            <v-flex md6 offset-md3 xs12 v-if="externalDriver == false">
                <v-btn @click="externalDriver = true" color="warning" class="mt-12" width="100%"> <v-icon left>connect_without_contact</v-icon>Motorista tercerizado </v-btn>
            </v-flex>

            <v-flex md6 offset-md3 xs12 v-if="externalDriver == true">
                <v-text-field :label="$t('Nome do motorista')" v-model="item.driverExternal" :rules="[rules.required, rules.min(5)]" clearable
                    v-on:keyup.enter="selectExternalUser" />
                <v-btn @click="selectExternalUser" color="success" class="mt-12" width="100%"> <v-icon left>navigate_next</v-icon>Próximo</v-btn>
            </v-flex>
            <UserList endpoint="checklists/return/users" @selected="selectUser" v-else />
        </v-layout>

        <v-layout wrap v-else-if="step == 2">
            <v-flex xs12>
                <v-form ref="formStep2" @submit.prevent="">
                    <v-text-field :label="$t('Digite o número de pedidos')" v-model="item.ordersNumber" :rules="[rules.required, rules.range(1, 1000)]" type=" number" clearable
                        v-on:keyup.enter="startBip" ref="ordersNumberField" />
                </v-form>
            </v-flex>
            <v-flex xs12>
                <v-btn color="success" :disabled="item.ordersNumber == null" @click="startBip" class="mx-auto" width="100%">
                    Iniciar Bipagem
                </v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap v-else-if="step == 3">
            <v-flex xs12 sm6 md6 class="pa-0 pb-4">
                <v-card :color="reachedGoal ? 'success' : 'grey'">
                    <v-card-text class="white--text">
                        <div class="headline mb-2">
                            <v-icon dark>luggage</v-icon>
                            {{ item.ordersNumber }}
                        </div>
                        Número de pedidos informado
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-btn @click="showQRCode = true" color="success" class="mt-12" width="100%"> <v-icon left>qr_code_scanner</v-icon>Bipar Pedido </v-btn>
            </v-flex>
            <v-flex xs12 mt-12>
                <v-btn color="error" @click="finishStep1" class="mx-auto" width="100%">Encerrar bipagem</v-btn>
            </v-flex>
        </v-layout>

        <BarCode :show="showQRCode" @close="showQRCode = false" manual @onRead="readedQRCode" />
        <ConfirmModal confirmText="Confirmar" cancelText="Cancelar" ref="confirm" />

        <MessageDialog :options="messageDialogOption" @close="closeBeepFeedback">
            <template slot="afterMessage">
                <div class="white--text" v-if="codeBippedToCheck">{{ $t("Código lido:") }} {{ codeBippedToCheck }}</div>
            </template>
        </MessageDialog>
    </v-container>
</template>

<script>
import rules from "@/helpers/rules";

import MessageDialog from "@/components/core/MessageDialog";
import ConfirmModal from "@/components/core/ConfirmModal";
import BarCode from "@/components/core/BarCode";
import StoreList from "@/components/shared/StoreList";
import UserList from "@/components/shared/UserList";
import ChecklistHistory from "@/components/shared/ChecklistHistory";

const itemClean = {
    extraCode: null,
    ordersNumber: null,
    store: null,
    driver: null,
    driverExternal: null,
};

export default {
    components: { MessageDialog, ConfirmModal, BarCode, StoreList, UserList, ChecklistHistory },

    data() {
        return {
            rules,
            loaded: false,
            filterName: null,
            showQRCode: false,
            messageDialogOption: undefined,
            externalDriver: false,
            driverName: null,
            codeBippedToCheck: null,
            step: null,
            item: JSON.parse(JSON.stringify(itemClean)),
            finishResult: null,
        };
    },

    computed: {
        hasDriver() {
            return this.item.driver || this.item.driverExternal;
        },
        reachedGoal() {
            return this.item && this.item.count >= this.item.ordersNumber;
        },
        inGoal() {
            return this.item && this.item.count == this.item.ordersNumber;
        },
        packagesBipped() {
            return this.item.ordersChecked ? this.item.ordersChecked.length : 0;
        },
        ordersBipped() {
            let a = this.item.ordersChecked;
            let uniqueArray = a.filter(function (item, pos) {
                return a.indexOf(item) == pos;
            });
            return uniqueArray.length;
        },
    },

    methods: {
        reopen(result) {
            if (result) {
                this.item = result;
                this.step = 3;
            }
        },
        readedQRCode(QRCode) {
            this.codeBippedToCheck = QRCode;
            this.bip();
        },
        start(store) {
            this.finishResult = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.item.store = store;
            this.step = 1;
        },
        selectUser(user) {
            this.driverName = user.name;
            this.item.driver = user.id;
            this.step = 2;
            this.$nextTick(() => this.$refs.ordersNumberField.focus());
        },
        selectExternalUser() {
            if (this.item.driverExternal && this.item.driverExternal.length >= 5) {
                this.driverName = this.item.driverExternal;
                this.step = 2;
                this.$nextTick(() => this.$refs.ordersNumberField.focus());
            } else {
                this.$eventHub.$emit("msgError", this.$t("Digite o nome do motorista"));
            }
        },
        startBip() {
            if (this.$refs.formStep2.validate())
                this.$http
                    .post(`checklists/return/create`, this.item)
                    .then((result) => {
                        if (result) {
                            this.item = result;
                            this.step = 3;
                        } else {
                            this.$eventHub.$emit("msgError", this.$t("Erro ao criar um romaneio"));
                        }
                    })
                    .catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao criar um romaneio"));
                    });
        },
        closeBeepFeedback() {
            if (this.inGoal) {
                this.$eventHub.$emit("msgSuccess", this.$t("Já foram bipados o número de pacotes informado."));
            } else {
                this.showQRCode = true;
            }
        },
        async bip() {
            this.showQRCode = false;
            this.messageDialogOption = { msg: "Conferindo...", type: "info" };

            if (this.codeBippedToCheck == null) {
                this.messageDialogOption = { msg: "Código inválido.", type: "critical" };
            } else {
                await this.$http
                    .patch(`checklists/return/bip/${this.item.code}`, { data: { store: this.item.store.id, ticket: this.codeBippedToCheck } })
                    .then((result) => {
                        if (result) {
                            if (result.created == true) {
                                this.messageDialogOption = { msg: "Pacote localizado e registrado, porém não foi localizada a coleta.", type: "warning", timer: 2000 };
                            } else if (result.extra && result.extra.expiredReturn == true) {
                                this.messageDialogOption = { msg: "Pacote devolvido com sucesso. O mesmo já foi coletado a mais de 4 dias e deve ser devolvido e não mais ser feito tentativa de entrega.", type: "critical" };
                            } else {
                                this.messageDialogOption = { msg: "Pedido localizado com sucesso.", type: "success" };
                            }
                            if (result.checklist) {
                                this.item = result.checklist;
                            }
                        } else {
                            this.messageDialogOption = { msg: "Pedido não localizado", type: "critical" };
                        }
                    })
                    .catch((error) => {
                        this.messageDialogOption = { msg: error.message ? error.message : this.$t("Erro ao localizar pedido"), type: "critical" };
                    });
            }
        },
        restartScreen() {
            this.loaded = false;
            this.showQRCode = false;
            this.codeBippedToCheck = null;
            this.step = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.finishResult = null;
            // this.getStores();
        },
        updateOrder() {
            this.$http
                .patch(`checklists/return/update/${this.item.code}`, { data: { extraCode: this.item.extraCode } })
                .then((result) => {
                    if (result) {
                        this.restartScreen();
                    } else {
                        this.$eventHub.$emit("msgError", this.$t("Erro ao atualizar dados do romaneio."));
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));

                });
        },
        finishStep1() {
            this.$refs.confirm.open("", "Deseja mesmo encerrar a devolução?").then((confirm) => {
                if (confirm) {
                    this.$http
                        .patch(`checklists/return/finish/${this.item.code}`)
                        .then(() => {
                            this.restartScreen();
                        })
                        .catch((error) => {
                            this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));
                        });
                }
            });
        },
    },
};
</script>